// extracted by mini-css-extract-plugin
module.exports = {"title":"PageTitle_title__3HRZO"};